import axios from "./axios-common";
const DEBUG=false;

//const disableCache = {
//      'Content-Type': 'application/json', //;charset=UTF-8',
//      'Cache-Control': 'no-cache',
//      'Pragma': 'no-cache',
//      'Expires': '0',
//    };
class AuthService {
  login(user) {
    const payload = {
          servis:   user.servis,
          username: user.username,
          password: user.password
    };
    return axios
      .post('/api/auth/signin', payload) //, {headers: disableCache})
      .then(response => {
        if(DEBUG) console.debug('AuthService', response?.data);
        if(!response.data) throw new Error('App login error - contact B4S');
        if(!response.data.accessToken) throw new Error('Nespravne heslo');
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        response.success = true;
        return response.data;
      },
      notOK => { console.log('NOT OK', notOK); throw new Error(notOK); }
      );
      //.catch(err=>{return { success: false, error: err }; });
  }

  getServisList(company){
    return axios
      .get('/login/servisList', { params: {company: company }})
      .then(response =>{
        if(DEBUG) console.log('####', company,  response);
        return response.data;
      });
  }

  logout() {
    // remove of accessToken should be enough
    try {
      const usrAuth = localStorage.getItem('user');
      const usrJson = JSON.parse(usrAuth);
      delete(usrJson.accessToken);
      localStorage.setItem('user', JSON.stringify(usrJson));
    } catch(err) {
      localStorage.removeItem('user');
    }
  }

  setPassword(user, newPassword) {
    const payload = {
          servis:   user.servis,
          username: user.username,
          password: user.password,
          newPassword: newPassword
    };
    return axios
      .post('/api/auth/setPassword', payload) //, {headers: disableCache})
      .then(response => {
        if(DEBUG) console.debug('AuthService setPassword', response?.data);
        if(!response.data) throw new Error('App login error - contact B4S');
        if(!response.data.accessToken) throw new Error('Neco se pokazilo');
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        response.success = true;
        return response.data;
      },
      notOK => { console.log('NOT OK', notOK); throw new Error(notOK); }
      );
      //.catch(err=>{return { success: false, error: err }; });
  }

  register(user) {
    return axios.post('/signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();
